const SET_ROUTERS = 'SET_ROUTERS';
const ROUTERS_DONE = 'ROUTERS_DONE';

const state = () => ({
  isRouteDone: false, // 是否生成了动态路由
  asyncRoutes: [],
});

const getters = {
  isRouteDone: state => state.isRouteDone,
  asyncRoutes: state => state.asyncRoutes,
};

const actions = {
  getAsyncRoute({ commit }, menus) {
    commit(SET_ROUTERS, menus);
  },
  GenerateRoutes({ commit }) {
    commit(ROUTERS_DONE);
  },
};

const mutations = {
  [SET_ROUTERS](state, routers) {
    state.asyncRoutes = routers;
  },
  [ROUTERS_DONE](state) {
    state.isRouteDone = true;
  },
};

const RouteStore = {
  state,
  getters,
  actions,
  mutations,
};

export default {
  install(store) {
    if (!store.state.Route) {
      store.registerModule(['Route'], RouteStore);
    }
  },
  uninstall(store) {
    store.unregisterModule(['Route']);
  },
};
